import { createStyles, Group, Stack, Text } from '@mantine/core';
import React from 'react';

import { ReactComponent as Calendar } from '@portals/icons/linear/calendar.svg';

import { CustomersCreationWidget } from './CustomersCreationWidget';
import { StatsWidgets } from './StatsWidgets';
import { BetaBadge } from '../../components/BetaBadge';

export function AnalyticsDashboard() {
  const { classes, theme } = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.contentContainer}>
        <Group spacing="xl" mb="xxl">
          <Text size={24}>Overview</Text>
          <BetaBadge />
        </Group>

        <Stack spacing="xxl">
          <Group spacing="xs" className={classes.timeContainer} w={125}>
            <Calendar width={18} height={18} color={theme.colors.gray[4]} />
            <Text color="gray.4">All time</Text>
          </Group>

          <StatsWidgets />
          <CustomersCreationWidget />
        </Stack>
      </div>
    </div>
  );
}

const useStyles = createStyles((theme) => ({
  container: {
    height: '100%',
    paddingInline: theme.spacing.xxl,
    paddingTop: 68,
    backgroundColor: theme.colors.gray[0],
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 1040,
    width: '100%',
    margin: '0 auto',
  },
  timeContainer: {
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    padding: `${theme.spacing.xs} ${theme.spacing.lg}`,
  },
}));
